import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Link } from "react-router-dom";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
});

function Estimator(props) {
  const classes = useStyles();
  const { years, currentProperty, ageArray } = props.store;
  const [mock10, setMock10] = useState([]);
  const [baseArray, setBaseArray] = useState([]);
  const [activeArray, setActiveArray] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    setActiveIndex(currentProperty.Prop_id);
  }, [currentProperty]);

  useEffect(() => {
    let dat = localStorage.getItem("mock10");
    setMock10(JSON.parse(dat));
  }, []);

  useEffect(() => {
    let tempArray = [];
    let tempBaseArray = [];
    mock10.map((mock) => {
      mock.prop_id === activeIndex ? tempArray.push(mock) : console.log("");
    });
    mock10.map((mock) => {
      mock.prop_id === 0 ? tempBaseArray.push(mock) : console.log("");
    });
    setActiveArray(tempArray);
    setBaseArray(tempBaseArray);
  }, [mock10]);

  function Sidebar(props) {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "start",
          textAlign: "start",
          marginTop: 8,
        }}
      >
        <div style={{ textAlign: "center" }}>
          <strong>
            <Link to="/map"> 10 Year Estimator</Link>
          </strong>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "start",
            marginTop: 20,
          }}
        >
          <div style={{ textAlign: "center", marginTop: 20 }}>
            <p style={{ fontWeight: "bold" }}>Annual Budget</p>
            <p>{props.store.targetTaxableBudgetS1}</p>
          </div>
          <div style={{ textAlign: "center", marginTop: 20 }}>
            <p style={{ fontWeight: "bold" }}>Additional Expenses</p>
            <p>{props.store.addlExpenses}</p>
          </div>
          <div style={{ textAlign: "center", marginTop: 20 }}>
            <p style={{ fontWeight: "bold" }}>Target Expense Reduction</p>
            <p>{props.store.targetSavings}</p>
          </div>
        </div>
        <div>
          <p style={{ textAlign: "center" }}>
            {currentProperty.street}, {currentProperty.city}{" "}
            {currentProperty.zip}
          </p>
        </div>
      </div>
    );
  }

  return (
    <div style={{ display: "flex" }}>
      <Sidebar {...props} />
      <TableContainer component={Paper}>
        <Table
          className={classes.table}
          size="medium"
          aria-label="a dense table"
        >
          <TableHead style={{ backgroundColor: "#00303F" }}>
            <TableCell style={{ color: "white" }}>Annual</TableCell>
            {years.map((year, index) => {
              return <TableCell style={{ color: "white" }}>{year}</TableCell>;
            })}
          </TableHead>

          <TableHead>
            <TableCell>Age</TableCell>
            {ageArray.map((element, index) => {
              return <TableCell>{element}</TableCell>;
            })}
          </TableHead>
          <h6
            style={{
              paddingLeft: 6,
              paddingTop: 10,
              textDecoration: "underline",
            }}
          >
            Home Base Totals
          </h6>
          <TableRow>
            <TableCell>Housing </TableCell>
            {baseArray.map((element, index) => {
              return <TableCell>{element.PrincipalNInterest}</TableCell>;
            })}
          </TableRow>
          <TableRow>
            <TableCell style={{ width: "200%" }}>Insurance </TableCell>
            {baseArray.map((element, index) => {
              return <TableCell> {element.HealthInsurance} </TableCell>;
            })}
          </TableRow>
          <TableRow>
            <TableCell>S&L Taxes </TableCell>
            {baseArray.map((element, index) => {
              return (
                <TableCell> {element.EstAnnualStateLocalIncomeTax} </TableCell>
              );
            })}
          </TableRow>

          <h6
            style={{
              paddingLeft: 12,
              paddingTop: 10,
              textDecoration: "underline",
            }}
          >
            New Property Totals
          </h6>

          <TableRow>
            <TableCell>Housing</TableCell>
            {activeArray.map((element, index) => {
              return <TableCell>{element.PrincipalNInterest}</TableCell>;
            })}
          </TableRow>
          <TableRow>
            <TableCell>Insurance </TableCell>
            {activeArray.map((element, index) => {
              return <TableCell>{element.HealthInsurance} </TableCell>;
            })}
          </TableRow>
          <TableRow>
            <TableCell>S&L Taxes </TableCell>
            {activeArray.map((element, index) => {
              return (
                <TableCell> {element.EstAnnualStateLocalIncomeTax} </TableCell>
              );
            })}
          </TableRow>

          <h6
            style={{
              paddingTop: 10,
              textDecoration: "underline",
              paddingRight: 10,
            }}
          >
            Expense Totals
          </h6>
          <TableRow>
            <TableCell>Home</TableCell>
            {baseArray.map((element, index) => {
              return <TableCell>{element.EstimatedYearlyCost} </TableCell>;
            })}
          </TableRow>

          <TableRow>
            <TableCell>New Property</TableCell>
            {activeArray.map((element, index) => {
              return <TableCell> {element.EstimatedYearlyCost} </TableCell>;
            })}
          </TableRow>
          <TableRow>
            <TableCell> Savings</TableCell>
            {activeArray.map((element, index) => {
              return <TableCell> {element.AnnualSaveCompToBase} </TableCell>;
            })}
          </TableRow>
          <h6
            style={{
              paddingTop: 10,
              textDecoration: "underline",
            }}
          >
            Residual Income
          </h6>
          <TableRow>
            <TableCell>Base </TableCell>
            {baseArray.map((element, index) => {
              let profit;
              if (
                element.EstimatedYearlyCost -
                  props.store.totalIncomeArray[index] <
                0
              ) {
                profit =
                  element.EstimatedYearlyCost -
                  props.store.totalIncomeArray[index];
              } else {
                profit = 0;
              }
              return <TableCell> {profit} </TableCell>;
            })}
          </TableRow>
          <TableRow>
            <TableCell>New Property</TableCell>
            {activeArray.map((element, index) => {
              let profit;
              if (
                element.EstimatedYearlyCost -
                  props.store.totalIncomeArray[index] <
                0
              ) {
                profit =
                  element.EstimatedYearlyCost -
                  props.store.totalIncomeArray[index];
              } else {
                profit = 0;
              }
              return <TableCell> {profit} </TableCell>;
            })}
          </TableRow>
        </Table>
      </TableContainer>
    </div>
  );
}
const mapStateToProps = (state) => {
  return {
    store: state,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Estimator);
